import { CSSObject } from '@chakra-ui/react';

export const Indicator = (): CSSObject => ({
  mt: '5px',
});
